import { Map } from 'immutable';

function updateVerifyEmailErrorMessage(state, message) {
  return state.set('error', message);
}

export default function (state = Map(), action) {
  switch (action.type) {
    case 'UPDATE_VERIFY_EMAIL_ERROR_MESSAGE':
      return updateVerifyEmailErrorMessage(state, action.message);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/verifyEmail.js